import { makeQuery } from 'shared/utilities';
import { NullableType } from "shared/types";

type RequestType = {
    file: File,
    onUploadProgress?: (progress: number) => void
}

type ResponseType = {
    item: any;
};


export const mediaTemporariesSaveQuery = async function (request: RequestType) {
    const formData = new FormData();
    formData.append('file', request.file);
    return await makeQuery<ResponseType>('/tmp-files/upload', { formData, onUploadProgress: request.onUploadProgress });
}
